import { render, staticRenderFns } from "./pageAdd.vue?vue&type=template&id=19ad476e&scoped=true&"
import script from "./pageAdd.vue?vue&type=script&lang=js&"
export * from "./pageAdd.vue?vue&type=script&lang=js&"
import style0 from "./pageAdd.vue?vue&type=style&index=0&id=19ad476e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ad476e",
  null
  
)

export default component.exports